import { AloveDialog, DialogType } from "components/alove/AloveDialog";
import { addAlert, useMaterialUIController } from "context";
import { GeneralCode } from "models/content/GeneralCode";
import React, { useEffect } from "react";
import { updateGeneralCodeDO } from "utils/generalCodesUtils";

const MDInput = require("components/MDInput").default;

export type EditGeneralCodeDialogProps = {
  entity: string;
  code: GeneralCode;
  refresh?: () => void;
};

export const EditGeneralCodeDialog = ({ entity, code, refresh }: EditGeneralCodeDialogProps) => {
  const [controller, dispatch] = useMaterialUIController();
  const [name, setName] = React.useState(code.name);

  const handleUpdate = async () => {
      await updateGeneralCodeDO(code.id, name);
      addAlert(dispatch, `${entity} updated`);
      if (refresh) refresh();
  };

  useEffect(() => {
    setName(code.name);
  }, [code]);

  return (
    <AloveDialog
      dialogType={DialogType.EditGeneralCode}
      dialogTitle={`Edit ${entity}`}
      dialogBody={`Edit the name of the ${entity}`}
      dialogConfirm="Save"
      valid={name?.length > 0}
      handleConfirm={handleUpdate}
    >
      <MDInput
        label={`${entity} Name`}
        required
        value={name}
        onChange={(e: any) => setName(e.target.value)}
      />
    </AloveDialog>
  );
}; 